import { useTranslation } from 'react-i18next';

const QuickInsertPage: React.FC = () => {
  const { t } = useTranslation('commons');
  return <span>{t('quickInsert')}</span>;
};

export default QuickInsertPage;
